import { setEditing } from "src/redux/slices/entrySlice";
import type { AppDispatch } from "src/redux/store";

type ScheduleHandler = () => void;

let scheduleHandler: ScheduleHandler | null = null;

export function registerAutosaveScheduleHandler(handler: ScheduleHandler) {
  scheduleHandler = handler;
  return () => {
    if (scheduleHandler === handler) {
      scheduleHandler = null;
    }
  };
}

export function requestAutosaveSchedule() {
  scheduleHandler?.();
}

export function triggerAutosaveForExternalChange(dispatch: AppDispatch) {
  dispatch(setEditing(true));
  requestAutosaveSchedule();
}
